import { Box, Grid, Icon, Typography, MenuItem, TextField } from "@mui/material"
import { grey } from "@mui/material/colors"
import { useEffect, useRef, useState } from "react"
import parsePhoneNumber from 'libphonenumber-js'
import MobileSteps from "../MobileSteps"
import InputForm from "../../forms/InputForm"
import ContainedButton from "../../actions/ContainedButton"
import CeluHeader from "./CeluHeader"

const CellphoneView = ({
        mobileForm,
        mobileCountryForm,
        onChange,
        loading,
        onReturn, 
        stepper,
        onRequestVerificationCode,
    }) => {

    const [valid, setValid] = useState(false)

    const mobileRef = useRef()

    useEffect(() => {
        const phonevalidation =  parsePhoneNumber(mobileForm?.value ?? '', 'MX')
        if(phonevalidation){
            const isValidPhone = phonevalidation.isValid()
            setValid(isValidPhone)
        }
    }, [mobileForm])

    useEffect(() => {
        if(mobileRef.current) mobileRef.current.focus()
    }, [])

    mobileForm.isValid = valid


    return(
        <Box
            sx={{fontFamily: (theme) => theme.typography.fontFamily}}
        >
            <CeluHeader
                title='Ingresa tu celular'
                enable_return onReturn={onReturn} 
            />
            <Box sx={{mt:4}}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <InputForm ref={mobileRef} data={mobileForm} 
                        startAdornment={<PhoneCodeAdornment
                            data={mobileCountryForm}    
                            onChange={onChange}
                        />} 
                        
                        onChange={onChange}
                        inputProps={{autocomplete:'new-password', form: {autocomplete: 'off'}}}/>
                    </Grid> 
                </Grid>
            </Box>
            <Typography variant="body2" sx={{mt:2}}>
                Enviaremos un mensaje con un código de verificación a este número.
            </Typography>
            <Box sx={{
                minHeight:'36vh',
                width:'100%',
                position:'relative',
                height:{
                    sm:'38vh'
                }
            }}/>
            <MobileSteps 
                position={stepper?.position ?? 0}
                steps={stepper?.steps ?? 1}
            />
            <ContainedButton 
                fullWidth
                disabled={!valid} 
                onClick={onRequestVerificationCode}
                loading={loading}
            >Enviar código</ContainedButton>
        </Box>
    )
}

export default CellphoneView

const PhoneCodeAdornment = ({
    data,
    onChange
}) => {

    const onInnerChange = (e) => {
        let _data2send = {
            ...data,
            isValid:true,
            isVisited:true,
            value: e.target.value
        }
        onChange(_data2send)

    }

    const option = data?.options?.find(el => el.value === data.value)

    return (
        <Box 
            sx={{
                borderRight:`1px solid ${grey[300]}`,
                pr:2, pl:1,
                mr:2,
                minWidth:100,
            }}
        >
            <Grid container wrap="nowrap" alignItems='center'>
                <Grid item>
                    <Box sx={{mr:1, width:24}}>
                        <img src={option?.icon} alt='' width={24} />
                    </Box>
                </Grid>
                <Grid item>
                    <TextField 
                        select
                        defaultValue={1}
                        value={data?.value}
                        variant='standard'
                        onChange={onInnerChange}
                        fullWidth
                        InputProps={{
                            disableUnderline:true,
                        }}
                    >
                        {data?.options.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
            </TextField>
                </Grid>
            </Grid>
            
        </Box>
    )
}